module.exports = __webpack_public_path__ + "static/media/image004.2562b58b.jpg";